import { downloadReport, exportAbsences, exportEntities } from "./admin";
import { exportDutyReport } from "./dutyReport";
import { exportPenaltyReport } from "./penaltyReport";
import { exportVerifyAttempts } from "./verifyLog";

// كل تبويب في صفحة التقارير يُصدَّر بمُصدِّره الخاص — لا يُصدَّر سجل الحضور للجميع.
const EXPORTERS = {
  attendance: (format, lang, filters) => downloadReport(format, lang, filters),
  entities: (format, lang, filters) => exportEntities(format, lang, filters),
  absences: (format, lang, filters) => exportAbsences(format, lang, filters),
  duties: (format, lang, filters) => exportDutyReport(format, lang, filters),
  penalties: (format, lang, filters) => exportPenaltyReport(format, lang, filters),
  verify: (format, lang, filters) => exportVerifyAttempts(format, lang, filters),
};

export const exportReportTab = (tab, format, lang, filters) =>
  (EXPORTERS[tab] || EXPORTERS.attendance)(format, lang, filters);
